import {useEffect} from 'react';
import io from 'socket.io-client';
import {logOutRequest} from "../../pages/Account/redux/actions";
import * as actionLogout from '../../pages/Account/redux/actions';
import * as actionAlbum from '../../pages/Album/redux/actions';
import {useDispatch} from "react-redux";
import {removeAllStorage} from "../../utils/helpers";
import {getPoint} from "../../pages/Giftbox/redux/actions";
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useAlbum } from './Album';
import API, { ROUTES } from '../api/api';
import { getAlbum } from '../../pages/Album/redux/actions';
import { getTimeVideoRenderRequest, resetVideoRender } from '../../pages/Video/redux/actions';
import ROUTERS from '../constans/router';
import { APP_NATIVE_VERSION, APP_ENV } from '../constans/app_version';
import {
  isAndroid,
  isIOS
} from "react-device-detect";

// let portStr = process.env.REACT_APP_SOCKET_PORT ? ':' + process.env.REACT_APP_SOCKET_PORT : ''
// const address = `${process.env.REACT_APP_SOCKET_HOST}${portStr}`;

function useCallSocket(token, userInfo) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const channel = process.env.REACT_APP_CHANNEL_PRE;
  console.log(25, window.appDevice?.appVersion);
  let address = process.env.REACT_APP_SOCKET_HOST_NEW_VERSION;

  // if (process.env.REACT_APP_ENV && process.env.REACT_APP_ENV === APP_ENV.PRODUCTION) {
  //   console.log('Android device', window.appDevice?.appVersion);
  //   if (isAndroid) {
  //     if (window.appDevice?.appVersion && window.appDevice?.appVersion === APP_NATIVE_VERSION.ANDROID) {
  //         address = process.env.REACT_APP_SOCKET_HOST_NEW_VERSION
  //       }else{
  //         address = process.env.REACT_APP_SOCKET_HOST
  //       }
  //     }
  //   if (isIOS) {
  //     console.log('IOS device', window.appDevice?.appVersion);
  //     if (window.appDevice?.appVersion && window.appDevice?.appVersion === APP_NATIVE_VERSION.IOS) {
  //       address = process.env.REACT_APP_SOCKET_HOST_NEW_VERSION
  //     }else{
  //       address = process.env.REACT_APP_SOCKET_HOST
  //     }
  //   }
  // } else {
  //   console.log(50, process.env.REACT_APP_ENV);
  //   address = process.env.REACT_APP_SOCKET_HOST_NEW_VERSION;
  // }

  console.log('url socket', address);
  useEffect(() => {
    const socket = io(address, {
      query: "token=" + token,
      transports: ['websocket']
    });

    window.socket = socket
    
    if(token){
      
      socket.on(`${channel}_private-user_${userInfo.id}`, res => {
        console.log(res, `${channel}_private-user_${userInfo.id}`);
        if (res.event.includes('PhotoUploaded')) {
          if (window.callFetchAlbumData) {
            window.callFetchAlbumData()
          }
        }else if(res.event.includes('AddPointUserEvent')){
          console.log('AddPointUserEvent');
          dispatch(getPoint())
        }else if(res.event.includes('UpdateAlbumBadgeCount')){
          console.log('UpdateAlbumBadgeCount', res);
          console.log('location', location);
          let dataUserUpdate = {
            ...userInfo,
            album_badge_count: res?.data?.count || 0
          }
          let param = {
            relation: ['characterPose', 'videoMessageTemplete']
          }
          console.log(54);
          dispatch(getTimeVideoRenderRequest(param));
          if (window.location && window.location.search === '?type=video_message') {
            //fetch video lists
            let params = {
              type: 'video_message',
              limit: 30,
              page: 1,
              group_by: 'date',
            }

            dispatch(getAlbum(params));

            var formData = new FormData();
            formData.append("album_badge_count", 0);

            dispatch(actionLogout.updateUserRequest(formData));

          }else{
            dispatch(actionLogout.updateSuccess(dataUserUpdate));
          }
        }else if(res.event.includes('UniqueLogin')) {
          console.log('UniqueLogin', res.data, window.appDevice.fcmToken);
          if (res.data && res.data.logout && window.appDevice.fcmToken !== res.data.fcmToken) {
            window.nativeLogoutToken(userInfo?.devices[0]?.login_type || 'N/A');
            window.logoutSNS(userInfo?.devices[0]?.login_type || 'N/A');

            dispatch(actionLogout.resetState());
            dispatch(actionAlbum.resetAlbum());
            removeAllStorage();
            dispatch(resetVideoRender());
            dispatch(logOutRequest());
            navigate(ROUTERS.LOGIN);
          }
        }else if(res.event.includes('AdminLocked')) {
          console.log('AdminLocked', res.data);
          //user logout bay admin locked
          if (res.data) {
            window.nativeLogoutToken(userInfo?.devices[0]?.login_type || 'N/A');
            window.logoutSNS(userInfo?.devices[0]?.login_type || 'N/A');
            dispatch(actionLogout.resetState());
            dispatch(actionAlbum.resetAlbum());
            removeAllStorage();
            dispatch(resetVideoRender());
            dispatch(logOutRequest());
            navigate(ROUTERS.LOGIN);
          }
        }
      })
      socket.on('sphokidz_global', res => {
        // console.log(res, 'sphokidz_global socker');
        //set state
      })

    }else{
      if(socket) {
        socket.disconnect();
        window.socket = undefined
      }
    }
    return (() => {
        if (socket) socket.close();
      }
    );
  },[token])

  return [];
}

export default useCallSocket;
